module.exports = "/assets/f3a9f714b0b52c3ffbeb9b753a24c0b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/CE.png
// module id = 2390
// module chunks = 0